<template>
  <div id="user-guides-tab">
    <p class="mt-5"><img :src="imagePath" alt="tutorials-tab" class="title_block-icon"></p>
    <p class="m-b-35 title">{{ $t("UserKit.user_guides_tab.coming_soon") }} !</p>

    <div class="m-b-150 message">
      <p>{{ $t("UserKit.user_guides_tab.message") }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserGuidesTab",
    computed: {
      imagePath() {
        return require('@/assets/img/pages/icons/icons8-coming-soon-100.png')
      }
    }
  }
</script>

<style lang="scss" scoped>
  #user-guides-tab {
    text-align: center;
    .title {
      font-size: 20px;
      color: #e51349;
      text-transform: uppercase;
    }

    .message {
      margin-left: auto;
      margin-right: auto;
      max-width: 470px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userKit/UserGuidesTab.vue